// import React from 'react';
// import offerImage from '../assets/Offer.jpg'; // Import the image

// const Offer = () => {
//   // Array of dummy data for each card
//   const offers = [
//     {
//       id: 1,
//       code: "FESTIVAL15",
//       validTill: "31st Oct 2024",

//     },
//     {
//       id: 2,
//       code: "NEWYEAR20",
//       validTill: "1st Jan 2025",

//     },
//     {
//       id: 3,
//       code: "SUMMER10",
//       validTill: "30th June 2024",

//     },
//   ];

//   return (
//     <div className="container mx-auto text-center py-10">
//       <h1 className="text-4xl font-bold text-yellow-600 mb-8">Offers</h1>
//       <div className="flex justify-center space-x-4">
//         {offers.map((offer) => (
//           <div key={offer.id} className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md p-4">
//             <img
//               className="rounded-t-lg w-full"
//               src={offerImage} // Use the imported image here
//               alt="Offer"
//             />
//             <div className="p-5 text-center">
//               <h2 className="text-lg font-bold text-gray-900">{offer.code}</h2>
//               <p className="text-gray-500 mb-4">Valid till {offer.validTill}</p>

//               <button className="mt-4 bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-4 rounded-lg">
//                 Book Now →
//               </button>
//               <a href="#" className="block mt-2 text-gray-500 underline">
//                 Terms & Condition
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Offer;


// import React, { useState } from 'react';
// import { Modal, Box, Typography, Button } from '@mui/material';
// import offerImage from '../assets/Offer.jpg';

// const Offer = () => {
//   // State for modal visibility
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Dummy data for each card
//   const offers = [
//     { id: 1, code: "FESTIVAL15", validTill: "31st Oct 2024" },
//     { id: 2, code: "NEWYEAR20", validTill: "1st Jan 2025" },
//     { id: 3, code: "SUMMER10", validTill: "30th June 2024" },
//   ];

//   // Function to handle modal open/close
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   return (
//     <div className="container mx-auto text-center py-10">
//       <h1 className="text-4xl font-bold text-[#FF9630] mb-8">Offers</h1>
//       <div className="flex justify-center space-x-4">
//         {offers.map((offer) => (
//           <div key={offer.id} className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md p-4">
//             <img
//               className="rounded-t-lg w-full"
//               src={offerImage} 
//               alt="Offer"
//             />
//             <div className="p-5 text-center">
//               <h2 className="text-lg font-bold text-gray-900">{offer.code}</h2>
//               <p className="text-gray-500 mb-4">Valid till {offer.validTill}</p>

//               {/* Book Now and Terms & Condition in the same row */}
//               <div className="flex justify-between items-center">
//                 <button className="bg-[#FF9630] hover:bg-[#FF9630] text-white font-bold py-2 px-4 rounded-lg">
//                   Book Now →
//                 </button>
//                 <a href="#" className="text-gray-500 underline" onClick={toggleModal}>
//                   Terms & Condition
//                 </a>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Modal for Terms & Condition */}
//       <Modal open={isModalOpen} onClose={toggleModal} aria-labelledby="terms-modal-title" aria-describedby="terms-modal-description">
//         <Box
//           sx={{
//             width: '70%',

//             bgcolor: 'background.paper',
//             borderRadius: '8px',
//             boxShadow: 24,
//             p: 4,
//             mx: 'auto',
//             mt: '10%',
//           }}
//         >
//           <Typography id="terms-modal-title" variant="h6" component="h2" className="text-center font-bold" style={{ color: '#FF7F50', backgroundColor: '#FF7F50', padding: '10px', borderRadius: '8px' }}>
//             Terms & Condition
//           </Typography>
//           <div className="text-left mt-4 text-gray-700 ">
//             <ul className="list-disc ml-4">
//               <li>Offer is valid only on Daily Rentals bookings made through the Moveonwheels website and iOS/Android app.</li>
//               <li>Offer is valid for bookings till 31st October’24.</li>
//               <li>Customer can get flat 15% off on Daily Rentals. Minimum Rental Amount should be Rs.3,000.</li>
//               <li>Discount is applicable only on rental amount and not on the security deposit.</li>
//               <li>Discount amount would be automatically calculated once customer enters promo code.</li>
//               <li>Customer cannot club 2 offers in one single transaction.</li>
//               <li>Moveonwheels has right to amend/withdraw offer anytime without prior intimation.</li>
//               <li>In case of any dispute, decision of Moveonwheels will be final and binding.</li>
//             </ul>
//           </div>
//           <div className="text-center mt-6">
//             <Button onClick={toggleModal} variant="contained" style={{ backgroundColor: '#FF7F50', color: 'white' }}>
//               OKAY
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Offer;

// import React, { useState } from 'react';
// import { Modal, Box, Typography, Button } from '@mui/material';
// import offerImage from '../assets/Offer.jpg';

// const Offer = () => {
//   // State for modal visibility
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Dummy data for each card
//   const offers = [
//     { id: 1, code: "FESTIVAL15", validTill: "31st Oct 2024" },
//     { id: 2, code: "NEWYEAR20", validTill: "1st Jan 2025" },
//     { id: 3, code: "SUMMER10", validTill: "30th June 2024" },
//   ];

//   // Function to handle modal open/close
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   return (
//     <div className="container  mx-auto text-center py-10 px-4">
//       <h1 className="text-3xl sm:text-4xl font-bold text-[#FF9630] mb-8">Offers</h1>
//       <div className="flex flex-wrap justify-center gap-6">
//         {offers.map((offer) => (
//           <div
//             key={offer.id}
//             className="w-full sm:w-80 md:w-96 bg-white rounded-lg border border-gray-200 shadow-md p-4"
//           >
//             <img
//               className="rounded-t-lg w-full h-48 object-cover"
//               src={offerImage}
//               alt="Offer"
//             />
//             <div className="mt-4 text-center">
//               <h2 className="text-xl font-semibold text-gray-900 text-left">{offer.code}</h2>
//               <p className="text-gray-500 mb-4 text-left">Valid till {offer.validTill}</p>

//               {/* Book Now and Terms & Condition in the same row */}
//               <div className="flex justify-between items-center">
//                 <button className="bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 px-4 rounded-full">
//                   Book Now →
//                 </button>
//                 <a href="#" className="text-gray-500 underline hover:text-[#FF9630]" onClick={toggleModal}>
//                   Terms & Condition
//                 </a>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Modal for Terms & Condition */}
//       <Modal
//         open={isModalOpen}
//         onClose={toggleModal}
//         aria-labelledby="terms-modal-title"
//         aria-describedby="terms-modal-description"
//       >
//         <Box
//           sx={{
//             width: { xs: '100%', sm: '80%', md: '60%' },
//             bgcolor: 'background.paper',
//             borderRadius: '8px',
//             boxShadow: 24,
//             mx: 'auto',
//             mt: '25%',

//           }}
//           className="max-w-full mx-auto bg-white rounded-lg shadow-lg "
//         >
//           <Typography
//             id="terms-modal-title"
//             variant="h6"
//             component="h2"
//             className="text-center font-bold text-white bg-[#FF9630] p-3 rounded-md mb-4"
//           >
//             Terms & Condition
//           </Typography>
//           <div className='p-4'>
//             <div className="text-left text-md mt-4 text-gray-700">
//               <ul className="list-disc pl-5 space-y-2">
//                 <li>Offer is valid only on Daily Rentals bookings made through the Moveonwheels website and iOS/Android app.</li>
//                 <li>Offer is valid for bookings till 31st October 2024.</li>
//                 <li>Customer can get flat 15% off on Daily Rentals. Minimum Rental Amount should be Rs.3,000.</li>
//                 <li>Discount is applicable only on rental amount and not on the security deposit.</li>
//                 <li>Discount amount would be automatically calculated once customer enters promo code.</li>
//                 <li>Customer cannot club 2 offers in one single transaction.</li>
//                 <li>Moveonwheels has right to amend/withdraw offer anytime without prior intimation.</li>
//                 <li>In case of any dispute, decision of Moveonwheels will be final and binding.</li>
//               </ul>
//             </div>
//             <div className="text-center mt-6 ">


//               <Button
//                 onClick={toggleModal}
//                 variant="contained"
//                 sx={{
//                   backgroundColor: '#FF9630', // Set the background to orange
//                   color: 'white',            // Text color white
//                   '&:hover': {               // Hover effect
//                     backgroundColor: 'FF9630',
//                   },
//                 }}
//                 className="w-full" // Apply only the width as a class
//               >
//                 OKAY
//               </Button>

//             </div>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Offer;

// import React, { useState } from 'react';
// import { Modal, Box, Typography, Button } from '@mui/material';
// import offerImage from '../assets/Offer.jpg';

// const Offer = () => {
//   // State for modal visibility
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Dummy data for each card
//   const offers = [
//     { id: 1, code: "FESTIVAL15", validTill: "31st Oct 2024" },
//     { id: 2, code: "NEWYEAR20", validTill: "1st Jan 2025" },
//     { id: 3, code: "SUMMER10", validTill: "30th June 2024" },
//   ];

//   // Function to handle modal open/close
//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   return (
//     <div className="container mx-auto text-center py-10 px-4">
//       <h1 className="text-3xl sm:text-4xl font-bold text-[#FF9630] mb-8">Offers</h1>
//       <div className="flex flex-wrap justify-center gap-6">
//         {offers.map((offer) => (
//           <div
//             key={offer.id}
//             className="w-full sm:w-80 md:w-96 bg-white rounded-lg border border-gray-200 shadow-md p-4"
//           >
//             <img
//               className="rounded-t-lg w-full h-48 object-cover"
//               src={offerImage}
//               alt="Offer"
//             />
//             <div className="mt-4 text-center">
//               <h2 className="text-xl font-semibold text-gray-900 text-left">{offer.code}</h2>
//               <p className="text-gray-500 mb-4 text-left">Valid till {offer.validTill}</p>

//               {/* Book Now and Terms & Condition in the same row */}
//               <div className="flex justify-between items-center">
//                 <button className="bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 px-4 rounded-full">
//                   Book Now →
//                 </button>
//                 <a href="#" className="text-gray-500 underline hover:text-[#FF9630]" onClick={toggleModal}>
//                   Terms & Condition
//                 </a>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Modal for Terms & Condition */}
//       <Modal
//         open={isModalOpen}
//         onClose={toggleModal}
//         aria-labelledby="terms-modal-title"
//         aria-describedby="terms-modal-description"
//       >
//         <Box
//           sx={{
//             width: { xs: '100%', sm: '80%', md: '60%' },
//             height: { xs: '100%', sm: 'auto' }, // Full height on mobile
//             bgcolor: 'background.paper',
//             borderRadius: { xs: '0', sm: '8px' }, // No border-radius on mobile
//             boxShadow: 24,
//             mx: 'auto',
//             mt: { xs: 0, sm: '25%' }, // Center modal vertically on larger screens
//             p: { xs: 2, sm: 4 }, // Padding for different screen sizes
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'space-between',
//           }}
//           className="max-w-full mx-auto bg-white rounded-lg shadow-lg"
//         >
//           <Typography
//             id="terms-modal-title"
//             variant="h6"
//             component="h2"
//             className="text-center font-bold text-white bg-[#FF9630] p-3 rounded-md mb-4"
//           >
//             Terms & Condition
//           </Typography>
//           <div className="p-4 flex-1 overflow-auto">
//             <div className="text-left text-md mt-4 text-gray-700">
//               <ul className="list-disc pl-5 space-y-2">
//                 <li>Offer is valid only on Daily Rentals bookings made through the Moveonwheels website and iOS/Android app.</li>
//                 <li>Offer is valid for bookings till 31st October 2024.</li>
//                 <li>Customer can get flat 15% off on Daily Rentals. Minimum Rental Amount should be Rs.3,000.</li>
//                 <li>Discount is applicable only on rental amount and not on the security deposit.</li>
//                 <li>Discount amount would be automatically calculated once customer enters promo code.</li>
//                 <li>Customer cannot club 2 offers in one single transaction.</li>
//                 <li>Moveonwheels has right to amend/withdraw offer anytime without prior intimation.</li>
//                 <li>In case of any dispute, decision of Moveonwheels will be final and binding.</li>
//               </ul>
//             </div>
//           </div>
//           <div className="text-center mt-6">
//             <Button
//               onClick={toggleModal}
//               variant="contained"
//               sx={{
//                 backgroundColor: '#FF9630', // Set the background to orange
//                 color: 'white',             // Text color white
//                 '&:hover': {                // Hover effect
//                   backgroundColor: '#FF9630',
//                 },
//               }}
//               className="w-full"
//             >
//               OKAY
//             </Button>
//           </div>
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default Offer;


import React, { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import offerImage from '../assets/Offer.jpg';

const Offer = () => {
  // State for modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Dummy data for each card
  const offers = [
    { id: 1, code: "FESTIVAL15", validTill: "31st Oct 2024" },
    { id: 2, code: "NEWYEAR20", validTill: "1st Jan 2025" },
    { id: 3, code: "SUMMER10", validTill: "30th June 2024" },
  ];

  // Function to handle modal open/close
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="container mx-auto text-center py-10 px-4">
      <h1 className="text-3xl sm:text-4xl font-bold text-[#FF9630] mb-8">Offers</h1>
      <div className="flex flex-wrap justify-center gap-6">
        {offers.map((offer) => (
          <div
            key={offer.id}
            className="w-full sm:w-80 md:w-96 bg-white rounded-lg border border-gray-200 shadow-md p-4"
          >
            <img
              className="rounded-t-lg w-full h-48 object-cover"
              src={offerImage}
              alt="Offer"
            />
            <div className="mt-4 text-center">
              <h2 className="text-xl font-semibold text-gray-900 text-left">{offer.code}</h2>
              <p className="text-gray-500 mb-4 text-left">Valid till {offer.validTill}</p>

              {/* Book Now and Terms & Condition in the same row */}
              <div className="flex justify-between items-center">
                <button className="bg-[#FF9630] hover:bg-[#FF9630] text-white font-semibold py-2 px-4 rounded-full">
                  Book Now →
                </button>
                <a href="#" className="text-gray-500 underline hover:text-[#FF9630]" onClick={toggleModal}>
                  Terms & Condition
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for Terms & Condition */}
      <Modal
        open={isModalOpen}
        onClose={toggleModal}
        aria-labelledby="terms-modal-title"
        aria-describedby="terms-modal-description"
      >
        <Box
          sx={{
            width: { xs: '100%', sm: '80%', md: '60%' },
            height: { xs: '100%', sm: 'auto' }, // Full height on mobile
            bgcolor: 'background.paper',
            borderRadius: { xs: '0', sm: '8px' }, // No border-radius on mobile
            boxShadow: 24,
            mx: 'auto',
            mt: { xs: 0, sm: '8%' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
          className="max-w-full mx-auto bg-white  shadow-lg"
        >
          <Typography
            id="terms-modal-title"
            variant="h6"
            component="h2"
            className="text-center font-bold text-white bg-[#FF9630] p-3 rounded-md mb-4"
          >
            Terms & Condition
          </Typography>
          <div className="p-4 flex-1 overflow-auto">
            <div className="text-left text-md mt-4 text-gray-700">
              <ul className="list-disc pl-5 space-y-2">
                <li>Offer is valid only on Daily Rentals bookings made through the Moveonwheels website and iOS/Android app.</li>
                <li>Offer is valid for bookings till 31st October 2024.</li>
                <li>Customer can get flat 15% off on Daily Rentals. Minimum Rental Amount should be Rs.3,000.</li>
                <li>Discount is applicable only on rental amount and not on the security deposit.</li>
                <li>Discount amount would be automatically calculated once customer enters promo code.</li>
                <li>Customer cannot club 2 offers in one single transaction.</li>
                <li>Moveonwheels has right to amend/withdraw offer anytime without prior intimation.</li>
                <li>In case of any dispute, decision of Moveonwheels will be final and binding.</li>
              </ul>
            </div>
          </div>
          <div className="text-center mt-6">
            <Button
              onClick={toggleModal}
              variant="contained"
              sx={{
                backgroundColor: '#FF9630', // Set the background to orange
                color: 'white',  
                p: 2,           // Text color white
                '&:hover': {                // Hover effect
                  backgroundColor: '#FF9630',
                 
                },
              }}
              className="w-full"
            >
              OKAY
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default Offer;
